// ProfitWell Retain widget. Mirrors ProfitWell's snippet: a queuing `profitwell`
// stub, then the loader script (which reads the auth token from the tag's
// `data-pw-auth`), then `start`. The signed-in user is attached via `user_email`.
// Loaded in dabble-accounts (where billing / cancellation live) as well as the
// writer, so the retention + cancellation-salvage flows have the widget present.
const SCRIPT_ID = 'profitwell-js';

type ProfitWell = ((command: string, ...args: unknown[]) => void) & {
  q?: unknown[][];
};

declare global {
  interface Window {
    profitwell?: ProfitWell;
  }
}

// Install the profitwell stub + loader script once. Calls before the script
// loads queue on `profitwell.q` and replay when the real script arrives.
function loadScript(token: string) {
  if (typeof document === 'undefined' || document.getElementById(SCRIPT_ID)) return;

  const stub: ProfitWell = (...args: unknown[]) => {
    (stub.q ??= []).push(args);
  };
  stub.q = [];
  window.profitwell = window.profitwell || stub;

  const script = document.createElement('script');
  script.async = true;
  script.id = SCRIPT_ID;
  script.setAttribute('data-pw-auth', token);
  script.src = `https://public.profitwell.com/js/profitwell.js?auth=${token}`;
  document.head.appendChild(script);
}

/** Load the ProfitWell Retain widget and start it. No-op without a token. */
export function loadProfitWell(token: string | undefined) {
  if (!token) return;
  loadScript(token);
  window.profitwell?.('start', {});
}

/** Attach the signed-in user by email. No-op until ProfitWell has loaded. */
export function identifyProfitWell(email: string | undefined) {
  if (!email) return;
  window.profitwell?.('user_email', email);
}
